/**
 * Montos tipo 2 con format (CLP): tolera valores legacy en BD con $ y separadores.
 */

export function isPreFormattedMontoValue(value: unknown): boolean {
  if (value == null || value === '') {
    return false;
  }
  const s = String(value).trim();
  if (s.includes('$')) {
    return true;
  }
  return (s.match(/\./g) || []).length >= 2;
}

/** Convierte string de monto (plano o formateado) a número; null si no es parseable. */
export function parseMontoToNumber(value: unknown): number | null {
  if (value == null || value === '') {
    return null;
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  const s = String(value)
    .trim()
    .replace(/\$/g, '')
    .replace(/\u00A0/g, ' ')
    .replace(/\s/g, '')
    .replace(/%/g, '');

  const withDecimalComma = /^([\d.]+),(\d{1,4})$/.exec(s);
  if (withDecimalComma) {
    const intPart = withDecimalComma[1].replace(/\./g, '');
    const n = parseFloat(`${intPart}.${withDecimalComma[2]}`);
    return Number.isFinite(n) ? n : null;
  }

  const dotCount = (s.match(/\./g) || []).length;
  if (dotCount >= 2) {
    const n = parseFloat(s.replace(/\./g, ''));
    return Number.isFinite(n) ? n : null;
  }

  const n = parseFloat(s.replace(/,/g, '.'));
  return Number.isFinite(n) ? n : null;
}

/** Valor canónico para guardar: solo dígitos (string). */
export function normalizeMontoForStorage(value: unknown): string {
  if (value == null || value === '') {
    return '';
  }
  const n = parseMontoToNumber(value);
  if (n != null) {
    return String(Math.round(n));
  }
  return String(value)
    .replace(/\$/g, '')
    .replace(/\./g, '')
    .replace(/,/g, '')
    .replace(/%/g, '')
    .trim();
}

/** Texto seguro para vista lectura (sin CurrencyPipe). */
export function displayMontoClp(value: unknown, format: boolean | null | undefined): string {
  if (value == null || value === '' || value === 'null') {
    return '';
  }
  if (!format) {
    return String(value);
  }
  const s = String(value).trim();
  if (isPreFormattedMontoValue(s)) {
    return s;
  }
  const n = parseMontoToNumber(s);
  if (n == null) {
    return s;
  }
  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    maximumFractionDigits: 0,
  }).format(n);
}
